var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelWebsite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 6.678A2.68 2.68 0 0 1 6.678 4h10.644A2.68 2.68 0 0 1 20 6.678v10.644A2.68 2.68 0 0 1 17.322 20H6.678A2.68 2.68 0 0 1 4 17.322zM18 7v1.5H6V7zM7 10.5h3v2H7zm4 0h6v2h-6zM7 14h4v3H7zm5 0h5v3h-5z",
  clipRule: "evenodd"
})));
export default SvgGemChannelWebsite;